export default __webpack_public_path__ + "0c51eb2e62d21ae0cfca5927d861fb6a.png";